export const formatOfflineReceiptCode = (value: string): string => {
  if (!value) {
    return '';
  }
  return value.slice(-6).toUpperCase();
};
